import React from 'react';
import { Modal, Typography } from 'antd';
import ParentList from '../components/ParentList';
import ChildList from '../components/ChildList';
import GridLayout from '../../../../shared/ui/GridLayout';
import ContentTitle from '../components/ContentTitle';

const title =
  'Некоторые исключаемые помещения находятся в связке с другими помещениями';

export const createConfirm = ({
  onOk,
  parentRooms,
  childRooms,
  currentHouseId,
}) => {
  Modal.confirm({
    title,
    content: (
      <Content
        parentRooms={parentRooms}
        childRooms={childRooms}
        currentHouseId={currentHouseId}
      />
    ),
    centered: true,
    onCancel: () => {},
    onOk,
  });
};

function Content({ parentRooms, childRooms, currentHouseId }) {
  return (
    <div>
      <GridLayout>
        {Boolean(parentRooms?.length) && (
          <div>
            <ContentTitle>Родительские помещения</ContentTitle>

            {parentRooms.map((room) => (
              <ParentList roomData={room} key={room.id} />
            ))}
          </div>
        )}

        {Boolean(childRooms?.length) && (
          <div>
            <ContentTitle>Дочерние помещения</ContentTitle>

            {childRooms.map((room) => (
              <ChildList
                key={room.id}
                roomData={room}
                currentHouseId={currentHouseId}
              />
            ))}
          </div>
        )}
      </GridLayout>
      <Typography.Paragraph>Продолжить?</Typography.Paragraph>
    </div>
  );
}
